import { NgModule } from '@angular/core';
import { NotificationDirective } from './notification.directive';

@NgModule({
  declarations: [NotificationDirective],
  exports: [NotificationDirective]
})
export class NotificationModule {}
